import axios from "axios";
import GetUserInfoService from "./GetUserInfoService";
import { locale } from "../utilities/locale/locale";

const REDIRECT_ENDPOINT = process.env.REACT_APP_AWS_STATIC_IP_REDIRECT_ENDPOINT;

export default class BanggoodService {
  async getProduct(payload) {
    let name = payload;
    let response = await axios({
      method: "GET",
      url: `${REDIRECT_ENDPOINT}/products?name=${name}`,
      data: payload,
      headers: {
        "X-API-KEY": "aa##ls_test2",
      },
    }).catch((e) => console.log(e));
    return response.data;
  }

  async getProductList(payload) {
    let cat_id = payload.cat_id;
    let lang = locale || "en";
    let response = await axios({
      method: "GET",
      url: `${REDIRECT_ENDPOINT}/products?cat_id=${cat_id}&lang=${lang}&page=${payload.page}`,
      data: payload,
      headers: {
        "X-API-KEY": "aa##ls_test2",
      },
    }).catch((e) => console.log(e));
    return response.data;
  }

  async getProductInfo(payload) {
    const userInfoService = new GetUserInfoService();
    const res = await userInfoService.getWalletInfo(
      localStorage.getItem("__extraconomy_token"),
      localStorage.getItem("__extraconomy_username")
    );
    let currency = res?.result?.currency || "BRL";
    let response = await axios({
      method: "GET",
      url: `${REDIRECT_ENDPOINT}/getProductInfo?product_id=${payload.product_id}&lang=${payload.lang}&currency=${currency}`,
      headers: {
        "X-API-KEY": "aa##ls_test2",
      },
    }).catch((e) => console.log(e));
    return response.data;
  }

  async importOrder(payload) {
    let response = await axios({
      method: "POST",
      url: `${REDIRECT_ENDPOINT}/importOrder`,
      data: payload,
      headers: {
        "X-API-KEY": "aa##ls_test2",
      },
    }).catch((e) => console.log(e));
    return response.data;
  }

  async getTrackInfo(payload) {
    let response = await axios({
      method: "GET",
      url: `${REDIRECT_ENDPOINT}/getTrackInfo?order_id=${payload}`,
      data: payload,
      headers: {
        "X-API-KEY": "aa##ls_test2",
      },
    }).catch((e) => console.log(e));
    return response.data;
  }
  async getOrderInfo(payload) {
    let response = await axios({
      method: "GET",
      url: `${REDIRECT_ENDPOINT}/getOrderInfo?sale_record_id=${payload}`,
      data: payload,
      headers: {
        "X-API-KEY": "aa##ls_test2",
      },
    }).catch((e) => console.log(e));
    return response.data;
  }
  async getOrderHistory(payload) {
    let response = await axios({
      method: "GET",
      url: `${REDIRECT_ENDPOINT}/getOrderHistory?order_id=${payload.order_id}&sale_record_id=${payload.sale_record_id}`,
      data: payload,
      headers: {
        "X-API-KEY": "aa##ls_test2",
      },
    }).catch((e) => console.log(e));
    return response.data;
  }
}
